// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  result: null
}

const campaign = (state = initialState, action) => {
  switch (action.type) {
    case 'CAMPAIGN_DATA':
      return {
        ...state,
        result: action.data
      }
    default:
      return { ...state }
  }
}

export { campaign }
